import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { scrollToCompra } from '../utils/scroll';
export function BonusesSection() {
  const bonuses = [{
    id: 1,
    title: 'Guía "Casa en Calma: Protocolo para Familias"',
    desc: 'El manual que te dice exactamente qué hacer cuando el niño se frustra, se bloquea o se niega a trabajar.',
    bullets: ['El Protocolo CALMA: 5 pasos para desescalar sin gritos', 'Qué decir y qué NO decir durante una sesión de trabajo', 'Cómo preparar el espacio físico para reducir distracciones', 'Rutina de inicio y cierre de cada sesión', 'Tabla de señales de sobrecarga sensorial'],
    closing: 'Para que la casa deje de ser un campo de batalla y se convierta en un espacio de aprendizaje.'
  }, {
    id: 2,
    title: 'Mini Agenda Visual para Nivel Inicial',
    desc: 'La agenda visual que el niño puede usar desde el primer día sin saber leer.',
    bullets: ['Pictogramas del Puente Visual Unificado', 'Secuencia de rutina diaria: mañana, tarde y noche', 'Versión para casa y versión para el aula', 'Instrucciones para plastificar y usar con velcro'],
    closing: 'Para que el niño sepa qué viene después sin necesitar que se lo repitan.'
  }, {
    id: 3,
    title: 'Agenda Visual para Primaria',
    desc: 'La versión avanzada con palabras + pictogramas para niños que ya reconocen algunas letras.',
    bullets: ['Combina pictogramas con palabras escritas', 'Incluye días de la semana y materias escolares', 'Espacio para tareas y actividades especiales', 'Transición gradual de pictograma puro a texto'],
    closing: 'Para que el niño empiece a leer su propia agenda sin darse cuenta.'
  }, {
    id: 4,
    title: 'Pack de Etiquetas Inteligentes para el Hogar',
    desc: 'Etiquetas con pictograma + palabra para pegar en objetos reales de la casa.',
    bullets: ['40 etiquetas listas para imprimir y plastificar', 'Objetos del baño, cocina, dormitorio y living', 'Mismo código visual que las fichas del kit', 'Guía de implementación: qué etiquetar primero'],
    closing: 'Para que cada objeto de la casa se convierta en una oportunidad de lectura.'
  }, {
    id: 5,
    title: 'Checklist "Ruta de Progreso"',
    desc: 'El mapa completo de habilidades con casilleros para marcar cada logro.',
    bullets: ['Lista de 150 habilidades organizadas por tomo', 'Casillero de verificación para cada habilidad', 'Indicadores claros de cuándo avanzar al siguiente nivel', 'Espacio para observaciones del adulto'],
    closing: 'Para que nunca más te preguntes "¿y ahora qué sigue?"'
  }, {
    id: 6,
    title: 'Tablero de Seguimiento Semanal',
    desc: 'El registro visual que te permite ver el avance semana a semana.',
    bullets: ['Grilla semanal con espacio para cada día', 'Registro de fichas trabajadas y nivel de respuesta', 'Sección de observaciones y ajustes', 'Versión imprimible para carpeta o cuaderno'],
    closing: 'Para que tengas evidencia concreta cuando alguien te pregunte "¿cómo va?"'
  }, {
    id: 7,
    title: 'Guía "Implementación Express: 7 Días de Arranque"',
    desc: 'El plan anti-abrumo para empezar hoy y ver avances esta semana. Sin excusas.',
    bullets: ['Día 1: preparar el espacio y primer contacto sin presión', 'Día 2: el primer trazo', 'Día 3: el límite y el color', 'Día 4: la direccionalidad de izquierda a derecha', 'Día 5: la primera vocal', 'Día 6: el primer trazado de letra', 'Día 7: la celebración y el plan de la semana 2'],
    closing: 'Para que el "después empiezo" se convierta en "empecé el lunes."'
  }];
  return <section className="py-20 px-4 bg-gray-50" data-id="element-16">
      <div className="max-w-5xl mx-auto" data-id="element-17">
        <div className="text-center mb-16" data-id="element-18">
          <span className="text-5xl mb-4 block" data-id="element-19">🎁</span>
          <h2 className="text-4xl md:text-5xl font-black text-[#111111] mb-6" data-id="element-20">
            7 BONOS INCLUIDOS HOY
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-21">
            Herramientas complementarias diseñadas para asegurar el éxito del
            sistema en tu casa y en el aula.
          </p>
        </div>

        <div className="flex justify-center mb-16" data-id="element-22">
          <img src="https://cdn.magicpatterns.com/uploads/kUEsDKg5zmDB3j6uvVzXP7/WhatsApp_Image_2026-03-17_at_8.55.38_PM-removebg-preview.png" loading="lazy" decoding="async" alt="Bonos del Mega Kit" className="w-full max-w-md h-auto object-contain drop-shadow-xl cursor-pointer hover:scale-105 transition-transform duration-300" onClick={scrollToCompra} data-id="element-23" />
        </div>

        <div className="space-y-8" data-id="element-24">
          {bonuses.map((bonus, idx) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white rounded-3xl p-6 md:p-10 shadow-sm border border-gray-100 relative overflow-hidden" data-id="element-25">
              <div className="absolute top-0 right-0 bg-[#C4A7E7] text-[#111111] font-bold px-6 py-2 rounded-bl-2xl shadow-sm" data-id="element-26">
                Hoy GRATIS
              </div>

              <div className="pr-24" data-id="element-27">
                <h3 className="text-2xl md:text-3xl font-bold text-[#111111] mb-4 flex items-center gap-3" data-id="element-28">
                  <span className="text-3xl" data-id="element-29">🎁</span>
                  <span data-id="element-30">
                    Bono #{bonus.id} — {bonus.title}
                  </span>
                </h3>

                <p className="text-lg text-gray-700 mb-6 font-medium" data-id="element-31">
                  {bonus.desc}
                </p>

                <ul className="space-y-3 mb-6" data-id="element-32">
                  {bonus.bullets.map((bullet, bIdx) => <li key={bIdx} className="flex items-start gap-3" data-id="element-33">
                      <CheckIcon className="w-5 h-5 text-[#C4A7E7] flex-shrink-0 mt-0.5" data-id="element-34" />
                      <span className="text-gray-600" data-id="element-35">{bullet}</span>
                    </li>)}
                </ul>

                <div className="bg-gray-50 p-4 rounded-xl" data-id="element-36">
                  <p className="text-[#C4A7E7] font-bold italic text-center md:text-left" data-id="element-37">
                    {bonus.closing}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}